<template>
    <rkm-data-table
        :fields="fields.datatables.procedimento"
        :repository="repositories.procedimento"
        ref="DataTable"
        sort-by="nome"
        search-by="nome"
    >
        <template v-slot:cell(codigo)="{ value }">
            {{ value | codigoProcedimento }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'parametrizacao-procedimento-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-parametrizacao-procedimento"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-parametrizacao-procedimento"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    procedimento: [
                        {
                            name: 'procedimento.codigo',
                            key: 'codigo',
                            label: 'Código',
                            searchable: true,
                            sortable: true,
                            class: 'col-min'
                        },
                        {
                            name: 'procedimento.nome',
                            key: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'parametrizacaoProcedimento.apelido',
                            key: 'apelido',
                            label: 'Apelido',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('parametrizacao.procedimento')
        }
    },
    filters: {
        codigoProcedimento: formats.formatProcedimento
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.procedimento.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a configuração do procedimento?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>